// src/supabaseClient.js
import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = 'https://cpdrgmixscwqsalxjlhf.supabase.co';
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImNwZHJnbWl4c2N3cXNhbHhqbGhmIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MjQ4NDAwMDgsImV4cCI6MjA0MDQxNjAwOH0.TpLQ6G__DDQFcFMDXuz1RVRHXDgisS4j1aVoJK7gv24';

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);
